const TrialCorn = () => {
    return (
        <svg width='26px' height='45px' viewBox='0 0 33 48' version='1.1' xmlns='http://www.w3.org/2000/svg'>
            <title>ensayo</title>
            <g id='markers-' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
                <g id='1.30.1markers' transform='translate(-1113.000000, -277.000000)'>
                    <g id='ensayo' transform='translate(1114.000000, 279.000000)'>
                        <ellipse
                            id='Oval-Copy'
                            fill='#2C453E'
                            opacity='0.604079'
                            cx='14.5'
                            cy='44.5'
                            rx='11.5'
                            ry='1.5'
                        />
                        <g id='Group-2-Copy-7'>
                            <g
                                id='icon/-location-copy'
                                fill='#FECB0B'
                                fill-rule='nonzero'
                                stroke='#FECB0B'
                                stroke-width='1.6'
                            >
                                <path
                                    d='M15.1952937,-0.432941224 C19.4321306,-0.432941224 23.2637674,1.2806206 26.0362789,4.0531321 C28.8087904,6.8256436 30.5223523,10.6572804 30.5223523,14.8941174 C30.5223523,24.3230801 19.8983469,37.6097059 16.6848206,41.3801905 C16.0382522,42.1333574 15.7889758,42.4091694 15.7889758,42.4091694 C15.7889758,42.4091694 15.6240681,42.5916316 15.1943648,43.0465769 C14.808845,42.6385226 14.6016118,42.4091697 14.6016116,42.4091694 C14.6016113,42.4091692 14.3513452,42.13219 13.913807,41.623245 C10.4887328,37.6056111 -0.131764894,24.3212375 -0.131764894,14.8941174 C-0.131764894,10.6572804 1.58179693,6.8256436 4.35430843,4.0531321 C7.12681993,1.2806206 10.9584568,-0.432941224 15.1952937,-0.432941224 Z'
                                    id='Shape-Copy'
                                />
                            </g>
                            <rect
                                id='Rectangle'
                                stroke='#2C453E'
                                stroke-width='1.44'
                                x='8'
                                y='7'
                                width='14'
                                height='16'
                                rx='1.8'
                            />
                            <line
                                x1='12'
                                y1='11.5'
                                x2='18'
                                y2='11.5'
                                id='Line-Copy'
                                stroke='#2C453E'
                                stroke-width='1.44'
                                stroke-linecap='square'
                            />
                            <line
                                x1='12'
                                y1='15.5'
                                x2='18'
                                y2='15.5'
                                id='Line-Copy-2'
                                stroke='#2C453E'
                                stroke-width='1.44'
                                stroke-linecap='square'
                            />
                            <line
                                x1='12'
                                y1='19.5'
                                x2='18'
                                y2='19.5'
                                id='Line-Copy-3'
                                stroke='#2C453E'
                                stroke-width='1.44'
                                stroke-linecap='square'
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default TrialCorn;
